import { createStatsProSlice } from '../statsProSlice';

/**
 * @typedef {StatsProState & {
 * 		modalVisible: boolean,
 * 		playerOne: string | null,
 * 		playerTwo: string | null
 * }} PlayerComparisonState
 */

/**
 * @type {PlayerComparisonState}
 */
const initialState = {
    modalVisible: false,
    playerOne: null,
    playerTwo: null
};

const reducers = {
    setPlayerSelectionModalVisibility: (state, action) => {
        state.modalVisible = action.payload;
    },
    setPlayer: (state, action) => {
        const { id, key } = action.payload;
        // If supplied with a key, try and update that side
        if (key) {
            if (key === 1) {
                state.playerOne = id;
            } else if (key === 2) {
                state.playerTwo = id;
            }
            // Otherwise, check for empty players
        } else if (!state.playerOne) {
            state.playerOne = id;
        } else if (!state.playerTwo) {
            state.playerTwo = id;
        }
    },
    removePlayer: (state, action) => {
        if (state.playerOne === action.payload.id) {
            state.playerOne = null;
        } else if (state.playerTwo === action.payload.id) {
            state.playerTwo = null;
        }
    }
};

export const playerComparisonSlice = createStatsProSlice({
    name: 'player-comparison',
    initialState,
    reducers
});

export const playerComparisonReducer = playerComparisonSlice.reducer;
export const playerComparisonActions = playerComparisonSlice.actions;
